import SparkMD5 from "spark-md5";
const readChunkAsArrayBuffer = async (chunk) => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader()
		reader.onload = () => resolve(reader.result)
		reader.onerror = reject
		reader.readAsArrayBuffer(chunk)
	})
}
const yieldToBrowser = () => new Promise((resolve) => setTimeout(resolve, 0))

export const calculateHashes = async (file, CHUNK_SIZE) => {
	const totalChunks = Math.ceil(file.size / CHUNK_SIZE)
	const fileSpark = new SparkMD5.ArrayBuffer()  // 文件整体hash
	const chunks = []                              // 分片数据

	for (let i = 0; i < totalChunks; i++) {
		const start = i * CHUNK_SIZE
		const end = Math.min(start + CHUNK_SIZE, file.size)
		const chunk = file.slice(start, end)

		// 1. 计算分片hash
		const chunkSpark = new SparkMD5.ArrayBuffer()
		let arrayBuffer = await readChunkAsArrayBuffer(chunk)
		chunkSpark.append(arrayBuffer)
		const chunkHash = chunkSpark.end()

		// 2. 追加到文件整体hash
		fileSpark.append(arrayBuffer)

		// 3. 保存分片数据
		chunks.push({
			index: i,
			data: chunk,
			hash: chunkHash
		})

		// 4. 释放内存
		arrayBuffer = null
		await yieldToBrowser()
	}

	// 计算文件最终hash
	const fileHash = fileSpark.end()

	return {
		fileHash,      // 文件整体标识
		chunks,        // 分片数据
		totalChunks
	}
}
